import { Box, Divider, Drawer, IconButton, Stack, Typography } from "@mui/material"
import { BoxMain, BtnTags, DrawerStyle } from "./style"
import { IconClose } from "../../../../../icons/IconClose"
import { IProjectResponse } from "../../../../../api/types"
import { formatApiDateToDdMmYyyy } from "../../../../../utils/common"
import { ProjectTeamSection } from "../../../ProjectTeamSection"
import { SourceSocialOrderSection } from '../../../SourceSocialOrderSection'
import { ProjectTagButton } from '../../../ProjectTagButton'

interface InfoDetailsDrawerProps {
    open: boolean
    onClose: () => void
    project: IProjectResponse
    onOpenAllMembers: () => void
}

export const InfoDetailsDrawer = ({ open, onClose, project, onOpenAllMembers }: InfoDetailsDrawerProps) => {
    const membersCount = Number(project.counters?.members ?? 0)
    const teamPreview = (project.team_preview ?? []).slice(0, 5)

    return (
        <Drawer 
            anchor="bottom"
            open={open}
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: DrawerStyle,
                },
            }}
        >
            <Box sx={BoxMain}>
                <Stack direction="row" justifyContent="flex-end" width="100%" alignItems="center">
                    <IconButton onClick={onClose}>
                        <IconClose fontSize="small" />
                    </IconButton>
                </Stack>
                <Stack gap={1}>
                    <Typography variant='black-14-medium' sx={{ lineHeight: '18px' }}>Единоразовый проект</Typography>
                    <Divider />
                    <SourceSocialOrderSection sourceSocialOrder={project.source_social_order} />
                    <ProjectTeamSection
                        members={teamPreview}
                        membersTotal={membersCount}
                        onOpenAllMembers={onOpenAllMembers}
                    />
                    <Divider />
                    <Stack gap={0.5}>
                        <Typography variant="black-14-light" component="div">Создан: {formatApiDateToDdMmYyyy(project.created_at)}</Typography>
                        {project.updated_at && (
                            <Typography variant="black-14-light">Отредактирован: {formatApiDateToDdMmYyyy(project.updated_at)}</Typography>
                        )}
                        <Typography variant="black-14-light" component="div" sx={{ overflowWrap: 'anywhere' }}>Местоположение: {project.region}</Typography>
                    </Stack>
                    
                    {project.tags != null && project.tags.length > 0 && (
                        <>
                            <Divider />
                            <Typography variant="black-14-medium" component="div" sx={{ lineHeight: '18px' }}>Направления:</Typography>
                            <Stack direction="row" gap={1.5} flexWrap="wrap">
                                {project.tags.map((tag, index) => (
                                <ProjectTagButton
                                    key={`${tag}-${index}`}
                                    tag={tag}
                                    sx={BtnTags}
                                />
                                ))}
                            </Stack>
                        </>
                    )}
                </Stack>
            </Box>
        </Drawer>
    )
}
